/**
 * SISTEMA DE AUTO-REGISTRO DE COMPONENTES
 * Detecta automáticamente todos los componentes en /sections/
 * Elimina la necesidad de registros manuales múltiples
 */
import { lazy } from "react";

const componentModules = import.meta.glob("../components/sections/*.jsx", {
  eager: false,
});

const COMPONENTS = {};

for (const path in componentModules) {
  const componentName = path.split("/").pop().replace(".jsx", "");

  const kebabName = componentName
    .replace(/([A-Z])/g, "-$1")
    .toLowerCase()
    .replace(/^-/, "");

  COMPONENTS[kebabName] = lazy(() =>
    componentModules[path]()
      .then((module) => {
        const component = module.default || module[componentName] || module;

        if (!component) {
          console.warn(`No se pudo importar el componente: ${componentName}`);
          return { default: () => null };
        }

        return { default: component };
      })
      .catch((error) => {
        console.error(`Error importando ${componentName}:`, error);
        return { default: () => null };
      })
  );
}

export const getComponent = (type) => {
  const component = COMPONENTS[type];
  if (!component) {
    console.warn(
      `Componente no encontrado: ${type}. Disponibles: ${Object.keys(
        COMPONENTS
      ).join(", ")}`
    );
  }
  return component;
};

export const getAvailableComponents = () => Object.keys(COMPONENTS);

export const isComponentRegistered = (type) => !!COMPONENTS[type];

if (import.meta.env.DEV) {
  console.log("🎯 Componentes auto-registrados:", Object.keys(COMPONENTS));
}

export { COMPONENTS };
export default COMPONENTS;
